export default "__VITE_ASSET__uVRMrObU__"